module.exports = __webpack_public_path__ + "img/lucretia-mott.1cf62c38.png";